import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { saveAs } from 'file-saver';


import { PescadorService } from './../../services/solicitante/pescador.service';
import { SolicitanteService } from 'src/app/services/solicitante/solicitante.service';
import { Solicitante } from 'src/app/models/solictante';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS } from 'src/app/config/config';
import { FileService } from 'src/app/services/file.service';

@Component({
  selector: 'app-listadoticketgestor',
  templateUrl: './listadoticketgestor.component.html',
  styleUrls: ['./listadoticketgestor.component.css']
})
export class ListadoticketgestorComponent implements OnInit {
  nombreArchivoBajar: string;


  @ViewChild('cantidad', { static: true }) cantidad: ElementRef;
@ViewChild('descripcion', { static: true }) descripcion: ElementRef;

  constructor(
    private solicitanteService: SolicitanteService,
    private pescadorService: PescadorService,
    private _fileService: FileService
  ) { }

  solicitante: string;

  ngOnInit() {
    console.log (localStorage.getItem('id'));
    this.solicitanteService.ListadoTicketsolucionado(localStorage.getItem('id'), true)
    .subscribe (respuesta => this.solicitante = respuesta
        );
  }


  muestradatosPescadores(listado: Solicitante) {

    this.nombreArchivoBajar = listado.numeroperacion.concat ('.pdf');
    console.log (this.nombreArchivoBajar);

    this.pescadorService.nuestraPescadorSeleccionado (listado._id)
    .subscribe ( resp => {

      console.log ( resp[0].cantidad);
      this.cantidad.nativeElement.value = resp[0].cantidad;
      this.descripcion.nativeElement.value = resp[0].tipolicencia;
      this.descripcion.nativeElement.value = resp[0].tipolicencia;


    });


  }


  download(){
    var filename = this.nombreArchivoBajar;
    console.log ('nombre dle archivo filename', filename);

    this._fileService.downloadFilePDF(filename)
    .subscribe(
        data => saveAs(data, filename),
        error => console.error(error)
    );
  }

}
